<template>
  <div class="panel panel-gray wraper">
    <div class="panel-header">
      <q-input
          name="filter"
          v-model="filter"
          float-label="&#128269; в названии"
          clearable
          style="width: 400px;"
      />
    </div>
    <div class="panel-group" :class="{scroll: $route.meta.showLeft}">
      <q-tree
          :nodes="hospitals"
          node-key="_id"
          :selected.sync="selected"
          :filter="filter"
      />
      <q-btn
          v-back-to-top.animate="500"
          round
          color="teal-5"
          class="fixed-bottom-left"
          style="margin: 0 0 15px 15px"
      >
        <q-icon name="keyboard_arrow_up" />
      </q-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'treeView',
  data() {
    return {
      filter: '',
    };
  },
  computed: {
    hospitals() {
      return this.$store.getters.normalizedHospitals.slice().sort((a, b) => {
        if (a.isDef === b.isDef) {
          if (a.city === b.city) {
            return a.abbr.localeCompare(b.abbr);
          }
          return a.city.localeCompare(b.city);
        }
        return a.isDef ? -1 : 1;
      });
    },
    selected: {
      get() {
        console.log('this.$route.params', this.$route.params);
        return this.$route.params.id || null;
      },
      // сеттер:
      set(newValue) {
        if (newValue) {
          this.$router.push(`/list/${newValue}`);
        } else {
          console.log('oops!'); // if click on already selected item
        }
      },
    },
  },
  watch: {
  },
};
</script>

<style lang="stylus">
  .my-padding
    padding 1rem 1rem
    margin auto
</style>



// WEBPACK FOOTER //
// src/components/tree-view.vue